import React from 'react'
import '../../style/FaiDaTe/FaiDaTe.scss'
import HeaderBack from './_HeaderBack'
import voltura from '../../assets/img/voltura.svg'
import listino from '../../assets/files/kit_contrattuale_web.pdf'
import { useSelector } from 'react-redux'


function Voltura() {
    const pod = useSelector((user) => user.user.info.pod_code)
    const costo = useSelector((user) => user.faidate.costi)

    return (
        <div className="faiDaTe_component">
            <HeaderBack text="Fai da te" step={0} />
            <div className="icon">
                <img src={voltura && voltura} alt="voltura" />
            </div>
            <div className="body">
                <div className="paragraph">
                    <h1 className="h1">Voltura</h1>
                    <p>Con la voltura puoi cambiare intestazione al tuo contratto senza interrompere la fornitura di energia elettrica.</p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Cos'è una voltura?</h2>
                    <p>CUna voltura è una variazione della titolarità di una fornitura da un cliente ad un altro con lo stesso venditore senza interruzione dell’erogazione di energia elettrica.
                        Per saperne di più vai su nostro blog <a href="https://revoluce.zendesk.com/hc/it/articles/360017592817-Hai-bisogno-di-fare-una-voltura-Ecco-come-farla-in-3-semplici-passi">cliccando qui</a>
                    </p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Tempi e Costi</h2>
                    <p><span className="bold">Tempo massimo di lavorazione:</span> 5 giorni lavorativi dalla richiesta del cliente.</p>
                    <p><span className="bold">Costo:</span> {costo !== null ? costo : ''}€ IVA inclusa (GRATIS se trattasi di voltura mortis causa).
                        Il costo della voltura verrà addebitato all’interno del primo Estratto Conto utile.
                    </p>
                </div>
                <div className="paragraph box">
                    <p><span className="bold">Fare una voltura equivale a sottoscrivere un nuovo contratto.</span></p>
                    <p>Ciò equivale a dire che il nuovo intestatario avrà un prezzo al kWh e un eventuale canone fisso mensile aggiornati secondo i prezzi attualmente in vigore, in base al “Listino prezzi Revoluce in vigore oggi” che puoi <a href={listino}>trovare qui.</a></p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Effettua una voltura</h2>
                    <p>Cliccando sul pulsante <span className="bold">RICHIEDI UNA VOLTURA</span> verrai reindirizzato alla compilazione di un nuovo contratto, compila tuttti i campi e alla domanda <span className="bold">"Devi fare una voltura, un cambio di potenza o destinazione d'uso?"</span> seleziona <span className="bold">SI inserendo nome,cognome e codice fiscale dell'attuale intestatario (ed eventuale MORTIS CAUSA).</span></p>
                </div>
            </div>
            <div className="cta">   
                <button><a href={`https://my.revoluce.it/adesione/index.php?id_agent=879&option=voltura&codice_pod=${pod}`}>Richiedi una voltura</a></button>
            </div>
        </div>
    )
}

export default Voltura
